/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Card,
  Row,
  Form,
  Col,
  Spin,
  Button,
  message,
  Tooltip,
} from 'antd';
import { DollarCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import { patchCorte } from 'api/recaudacion/cortes';
import { getTerminalesDeNetPay } from 'api/configuracion/terminalDeNetPay';

export const permissionConfig = {
  mainPermission: 'reasignarterminal_corte',
  required: ['view_terminaldenetpay', 'change_corte'],
};

const ReasignarTerminalNetpay = ({ permission }) => {
  const [form] = Form.useForm();
  const [terminalNetPay, setTerminalNetPay] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const corte = useSelector(({ app }) => app.corte);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      setLoading(true);
      if (!corte?.apertura) {
        setTimeout(() => history.push('/recaudacion/corte/abrir-corte/'));
        message.warn('Se necesita un corte abierto para poder acceder');
      }
      const _terminales = await getTerminalesDeNetPay();
      if (mounted) {
        setTerminalNetPay(_terminales);
        // form.setFieldsValue({ terminal_de_netpay: corte?.terminal_de_netpay.id });
      }
      setLoading(false);
    };
    fetchData();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [corte]);

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const updated = await patchCorte(corte.id, values);
      if (updated) {
        setLoading(false);
        setTimeout(() => history.push('/recaudacion/caja/'));
      }
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const rules = { required: [{ required: true }] };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Col span={24}>
          <Card
            bordered={false}
            className="form-container"
            title="Reasignar Terminal de Netpay"
            extra={permission?.change_corte ? (
              <Button
                icon={<DollarCircleOutlined />}
                type="link"
                onClick={onFinish}
              >
                Reasignar
              </Button>
            ) : (
              <Tooltip title="No tienes permisos para abrir corte">
                <Button
                  icon={<DollarCircleOutlined />}
                  type="link"
                  disabled
                >
                  Reasignar
                </Button>
              </Tooltip>
            )}
          >
            <Col span={24}>
              <Form
                layout="vertical"
                form={form}
                scrollToFirstError
                onFinish={() => onFinish()}
                initialValues={{ terminal_de_netpay: corte?.terminal_de_netpay?.id }}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={16} lg={12}>
                    <Form.Item
                      label="Terminal de Netpay"
                      name="terminal_de_netpay"
                      rules={rules.required}
                    >
                      <Select dataSource={terminalNetPay} />
                    </Form.Item>
                  </Col>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Row>
              </Form>
            </Col>
          </Card>
        </Col>
      </Spin>
    </Row>
  );
};
export default ReasignarTerminalNetpay;
